export class AuthenticationRequestEntity {
  username?: string;
  password?: string;
  isSavedForNextLogin?: boolean;
  email?: string;
  phone?: string;
  role?: string;
  name?: string;
  code?: string;
  status?: number;
  note?: string;
  order?: string;
  configuration?: any;
  features?: string[];
  referents?: string[];

  switchMode?(data: AuthenticationRequestEntity, mode: "login" | "signUp") {
    switch (mode) {
      case "login":
        return {
          username: data?.username,
          name: data?.name,
          password: data?.password,
          email: data?.email,
          phone: data?.phone,
        };
      case "signUp":
        return {
          username: data?.username,
          password: data?.password,
        };
    }
  }
}
